import "./index.css";

const MobileMenu = ({
  menu,
  setMenu,
  navLinks,
  subMenu,
  handleSubMenu,
  setSubMenu,
  location,
  NavLink,
}) => {
  return (
    <div
      className={`lg:hidden ${
        menu ? "is-active" : "not-active"
      } menu-bar-overlay fixed`}
    >
      <div className="pt-[60px] pb-[50px] text-center block absolute left-0 top-0 w-full h-full overflow-x-hidden">
        {/* Cross Button */}
        <div
          onClick={() => {
            setMenu(!menu); // Toggle menu
            setSubMenu(null); // Reset any sub-menu state
          }}
          className={`${!menu ? "close-btn-not-active" : ""} close-btn`}
        >
          <span className={`${menu ? "line-active" : ""}`}></span>
        </div>
        {/* cross button ends here */}
        <ul className="w-full py-[100px] relative mb-[10px] font-open text-base md:text-lg">
          {navLinks.map((parent, parentIndex) => {
            const hasChildren = parent.hasOwnProperty("children");
            let isActive = false;

            // Logic for "portfolio" parent
            if (hasChildren && parent.title === "portfolio") {
              isActive = parent.children.some(
                (child) => child.url === location.pathname
              );
            }

            // Logic for "services" parent
            else if (hasChildren && parent.title === "services") {
              isActive = parent.children.some(
                (child) =>
                  child.links &&
                  child.links.some((link) => link.url === location.pathname)
              );
            }

            return (
              <li
                key={parent.title}
                className={`${menu ? "link-active" : "link-not-active"}`}
              >
                {!hasChildren ? (
                  <NavLink
                    onClick={() => setMenu(!menu)}
                    to={parent.url}
                    className={({ isActive }) =>
                      `uppercase leading-[1.6] inline-block py-[0.17em] ${
                        isActive ? "text-[#cd2122]" : "text-black"
                      }`
                    }
                  >
                    {parent.title}
                  </NavLink>
                ) : (
                  <>
                    <span
                      onClick={() => handleSubMenu(parentIndex)}
                      className={`${
                        isActive ? "text-[#cd2122]" : "text-black"
                      } uppercase leading-[1.6] py-[0.17em] inline-block`}
                    >
                      <div className="link-title inline-block">
                      {parent.title}
                      </div>
                      
                      <div className="dropdown inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" class="my-svg" width="13" height="10" viewBox="0 0 9 6" fill="none">
                    <path d="M3.92877 5.1729L0.580521 1.82465C0.463038 1.70716 0.404297 1.5666 0.404297 1.40297C0.404297 1.23933 0.463038 1.10297 0.580521 0.993876L1.13437 0.427443C1.25185 0.318352 1.39241 0.263806 1.55605 0.263806C1.71968 0.263806 1.85605 0.318352 1.96514 0.427443L4.34416 2.80646L6.71059 0.427443C6.82807 0.318352 6.96863 0.263806 7.13227 0.263806C7.29591 0.263806 7.43227 0.318352 7.54136 0.427443L8.10779 0.993876C8.21688 1.10297 8.27143 1.23933 8.27143 1.40297C8.27143 1.5666 8.21688 1.70716 8.10779 1.82465L4.75954 5.1729C4.64206 5.29038 4.5015 5.34912 4.33786 5.34912C4.17423 5.34912 4.03786 5.29038 3.92877 5.1729Z" fill="#999999"></path>
                    </svg>
                    </div>
                    </span>
                    
                    {parent.title === "portfolio" ? (
                      
                      <ul
                        className={`w-100 transition-all duration-700 overflow-hidden ease-in-out ${
                          subMenu === parentIndex
                            ? "max-h-[500px] pb-[1em]"
                            : "max-h-0 pb-0"
                        }`}
                      >
                        {parent.children.map((child) => (
                          <li className="w-max m-auto client-li" key={child.title}>
                            <NavLink
                              onClick={() => {
                                setMenu(!menu);
                                setSubMenu(null);
                              }}
                              to={child.url}
                              className={({ isActive }) =>
                                `uppercase text-[14px] leading-[1.6] py-[0.17em] inline-block ${
                                  isActive ? "text-[#cd2122]" : "text-black"
                                }`
                              }
                            >
                              {child.title}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      // mega container
                      <ul
                        className={`w-full transition-all duration-700 ease-in-out overflow-hidden ${
                          subMenu === parentIndex
                            ? "max-h-[2000px] pb-[1em]"
                            : "max-h-0 pb-0"
                        }`}
                      >
                        {parent.children.map((child) => (
                          <li className="w-full" key={child.title}>
                            <>
                              <span className="inline-block mt-5 text-[#DA2128] uppercase font-[800] underline py-[0.17em]">
                                {child.title}
                              </span>
                              <ul className="w-full">
                                {child.links.map((child2) => {
                                  return (
                                    <li className="w-full" key={child2.title}>
                                      <NavLink
                                        onClick={() => {
                                          setMenu(!menu);
                                          setSubMenu(null);
                                        }}
                                        to={child2.url}
                                        className={({ isActive }) =>
                                          `uppercase leading-[1.6] py-[0.17em] inline-block ${
                                            isActive
                                              ? "text-[#cd2122]"
                                              : "text-black"
                                          }`
                                        }
                                      >
                                        {child2.title}
                                      </NavLink>
                                    </li>
                                  );
                                })}
                              </ul>
                            </>
                          </li>
                        ))}
                      </ul>
                      // mega container ends here
                    )}
                  </>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
